/**
 * Brand-related constants for IT360 Support Assistant
 * Centralizing shared values for easier maintenance and consistency
 */

// Logo URLs
export const LOGO_URL = 'https://it360.co.nz/wp-content/uploads/2018/11/it360-transparent-logo.png';
export const FAVICON_URL = 'https://it360.co.nz/wp-content/uploads/2019/09/cropped-favicon-3-270x270.png';

// App name
export const APP_NAME = 'IT360 Assistant';

// Document titles
export const PAGE_TITLES = {
  LOGIN: `${APP_NAME} - Login`,
  REGISTER: `${APP_NAME} - Register`,
  VERIFY_EMAIL: `${APP_NAME} - Email Verification`,
  DASHBOARD: APP_NAME,
  CHAT: APP_NAME,
};

// Company Information
export const COMPANY = {
  NAME: 'IT360',
  WEBSITE: 'https://it360.co.nz/',
  SUPPORT_EMAIL: 'support@it360.co.nz',
  SUPPORT_PHONE: '09 916 1180',
}; 